<script>
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
} from 'vue-feather-icons'
export default {
  data() {
    return {}
  },
  components: {
    // FacebookIcon,
    // InstagramIcon,
    // TwitterIcon,
    // LinkedinIcon,
    // MailIcon,
  },
}
</script>

<template>
  <div>
    <!-- Footer Start -->
    <footer class="footer">
      <div class="container p-5">
        <div class="row">
          <div class="col-lg-6 mb-4 px-5">
            <a href="/" class="logo-footer">
              <img src="/images/myuni/myUni.svg" height="70" alt="logo" />
            </a>
            <p class="mt-4 w-75">
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
              nonummy nibh euismod tincidunt ut laoreet dolore
            </p>
            <ul class="list-unstyled mb-0 mt-4">
              <li style="display: inline-block;" class="">
                <a target="_blank" href="https://www.linkedin.com/company/wwwmyunipk">
                  <img
                    src="/images/myuni/homepage/SVG/facebook_button.svg"
                    class="r-footer-soc-img-70"
                    height="50"
                    alt="logo"
                  />
                </a>
              </li>
              <li style="display: inline-block;">
                <a target="_blank" href="javascript:void(0)">
                  <img
                    src="/images/myuni/homepage/SVG/instagram_button.svg"
                    class="r-footer-soc-img-70"
                    height="50"
                    alt="logo"
                  />
                </a>
              </li>
              <!-- <li style="display: inline-block;">
                <a href="javascript:void(0)">
                  <img
                    src="/images/myuni/homepage/SVG/whatsapp_button.svg"
                    class="r-footer-soc-img-70"
                    height="50"
                    alt="logo"
                  />
                </a>
              </li> -->
              <li style="display: inline-block;">
                <a href="twitter.com/wwwmyunipk" target="_blank">
                  <img
                    src="/images/myuni/homepage/SVG/twitter_button.svg"
                    class="r-footer-soc-img-70"
                    height="50"
                    alt="logo"
                  />
                </a>
              </li>
            </ul>
            <!--end icon-->
          </div>
          <!--end col-->

          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-4 pt-2 pt-sm-0">
                <h4 class="text-light footer-head font-weight-bold">
                  Information
                </h4>
                <ul class="list-unstyled footer-list mt-4">
                  <li>
                    <a href="/privacy-policy" class="text-white">Privacy policy</a>
                  </li>
                  <li>
                    <a href="/terms-and-conditions" class="text-white">Terms and conditions</a>
                  </li>
                  <!-- <li>
                    <a href="#" class="text-white">Feedback</a>
                  </li> -->
                  <li>
                    <a href="/contact" class="text-white">Contact</a>
                  </li>
                </ul>
              </div>
              <!--end col-->

              <div class="col-lg-4 pt-2 pt-sm-0">
                <h4 class="text-light footer-head font-weight-bold">
                  Useful Links
                </h4>
                <ul class="list-unstyled footer-list mt-4">
                  <li>
                    <a href="#" class="text-white">Advertise your course</a>
                  </li>
                  <li></li>
                  <li>
                    <a href="#" class="text-white">Manage your listings</a>
                  </li>
                  <li>
                    <a href="/login" class="text-white">Register as an institute</a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="mt-4">
              <button class="r_footer_button_sub_case">
                Submit your course
              </button>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>

      <div class="w-100 text-center text-white" style="margin-top: 2rem;">
        <p class="mx-auto">
          © 2022 -
          <a href="" class="text-white">myUni.pk</a>
        </p>
      </div>
      <!--end container-->
    </footer>
    <!--end footer-->
  </div>
</template>

<style scoped>
.footer {
  background-color: #103154;
  padding: 60px 0 20px 0;
  margin-top: 3.25rem !important;
}
.font-weight-bold {
  font-weight: bold !important;
}
.r_footer_button_sub_case {
  border: 1px solid white !important;
  padding: 0.7rem 7rem;
  color: white !important;
  border-radius: 2rem;
  font-size: 20px !important;
}
.r-footer-soc-img-70 {
  width: 100% !important;
  margin: 10px 0 0 10px !important;
}

@media (max-width: 720px) {
  .r_footer_button_sub_case[data-v-3c4c2b3d] {
    border: 1px solid white !important;
    padding: 0.5rem 0 !important;
    color: white !important;
    width: 50% !important;
    border-radius: 2rem !important;
    font-size: 12px !important;
  }
  .r-footer-soc-img-70 {
    width: 70% !important;
    margin-left: 2px !important;
  }
}
</style>
